var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass,on:{"click":_vm.onWrapperClick}},[_c('AppTopBar',{on:{"menu-toggle":_vm.onMenuToggle}}),_c('div',{staticClass:"mt-3"},[_c('router-view')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }